import './header.scss';

export default async () => {
	$( '.header__menu-list > li > .header__menu-subitems' )
		.parent( 'li' )
		.addClass( 'has-children' );

	$( '.js-toggle-menu' ).click( function ( e ) {
		e.preventDefault();
		$( 'body' ).toggleClass( 'is-menu-open' );
	} );

	$( '.header__menu > ul > li > ul, .header__menu > ul > li > ul > li > ul' )
		.parent( 'li' )
		.addClass( 'has-children' );

	$( '.header__menu > ul > .has-children > a' )
		.append()
		.after(
			'<span class=\'header__arrow hide-for-xlarge js-menu-toggle\'><i class=\'icon-arrow\'></i></span>'
		);

	$( '.js-menu-toggle' ).on( 'click', function ( e ) {
		e.preventDefault();

		let $this = $( this );

		if ( $this.hasClass( 'is-active' ) ) {
			$this.removeClass( 'is-active' );
			$this.next().slideUp( 350 );
		} else {
			$this.parent().parent().find( '.js-menu-toggle' ).removeClass( 'is-active' );
			$this.parent().parent().find( '.has-children ul' ).slideUp( 350 );
			$this.toggleClass( 'is-active' );
			$this.next().slideToggle( 350 );
		}
	} );

	// Get the header
	// Let header = document.getElementById( 'header' );

	// Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position

	// Const observer = new IntersectionObserver(
	// 	( [ e ] ) => {
	// 		If ( e.isIntersecting ) {
	// 			Header.classList.remove( 'headerSticky' );
	// 			If ( window.scrollY < 2 ) {
	// 				$( '.header__top' ).slideDown();
	// 			}
	// 		} else {
	// 			Header.classList.add( 'headerSticky' );
	// 			$( '.header__top' ).slideUp();
	// 		}
	// 	},
	// 	{
	// 		Threshold: [ 1 ],
	// 	}
	// );

	// Observer.observe( header );
};
